import { useAuthorizedMutation } from "..";
import { params } from "../../params";

export const useImproveArticle = () => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/knowledge-base-handler/suggested-article`,
    method: "POST",
  });
};
